import { Component } from '@angular/core';
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { AlbumsService } from '../../services/albums.service';
import { UserService } from '../../services/user.service';

/**
 * Component providing a view of an album product item.
 */
@Component({
	selector: 'album-product-info',
	templateUrl: './album-product-info.component.html',
	styleUrl: './album-product-info.component.css'
})
export class AlbumProductInfoComponent implements OnInit, OnChanges {
	@Input() albumId: any;
	@Input() productId: any;

	LOCALIZATION: any;
	userPermissions: { [key: string]: any } = {};

	album: any = {};
	albumPage: any = {};

	canUpdate: boolean = false;
	isUpdate: boolean = false;
	input = {
		title: '',
		description: '',
		tags: null
	};
	limits = {
		description: 500,
		title: 255
	};

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private albumsService: AlbumsService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.userPermissions = this.userService.getUserPermissionsMap();

		this.loadAlbum();
		this.getProductAccess();
	}
	
	/**
	 * Reinitialize this component without destroying the DOM.
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes['productId']) {
			this.loadAlbum();
			this.getProductAccess();
		}
	}

	private getProductAccess(): void {
		this.albumsService.getAlbumProductDescription(this.albumId, this.productId).then(
			(response: any) => {
				switch (response.productAccessType) {
					case 'FULL':
					case 'DELETE':
					case 'CREATE':
					case 'EDIT':
						this.canUpdate = true;
						break;
					case 'RESTRICTED':
					case 'PROHIBITED':
					case 'PUBLIC':
					case 'READ':
						this.canUpdate = false;
						break;
					default:
						this.canUpdate = false;
				}
			},
			(err: any) => {
				console.error("Failed to fetch album product description.", err);
			}
		);
	}

	private loadAlbum(): void {
		this.albumsService.getAlbum(this.albumId).then(
			(response: any) => {
				this.album = response;
			},
			(err: any) => {
				console.error("Failed to fetch album.", err);
			}
		);

		this.albumsService.getAlbumDescription(this.albumId).then(
			(response: any) => {
				let albumPages = response;

				for (let idx = 0; idx < albumPages.length; idx++) {
					if (albumPages[idx].productId == this.productId) {
						this.albumPage = albumPages[idx];
						break;
					}
				}

				if (this.albumPage) {
					this.input.title = this.albumPage.pageMetadata.title;
					this.input.description = this.albumPage.pageMetadata.description;
					this.input.tags = this.albumPage.pageMetadata.tags;
				}
			},
			(err: any) => {
				console.error("Failed to fetch album pages.", err);
			}
		);
	}

	/**
	 * Saves the album page data.
	 */
	savePage(): void {
		this.albumsService.updateAlbumPageMetadata(this.album.id, this.productId, this.albumPage.page, this.input).then(
			(response: any) => {
				this.alertsService.success({
					message: this.LOCALIZATION.updateAlbumItemSuccess
				});
				this.toggleUpdate(false);
			},
			(err: any) => {
				console.error("Failed to update album page.", err);
				this.alertsService.error({
					message: this.LOCALIZATION.updateAlbumItemError
				});
			}
		);
	}

	toggleUpdate(on: boolean): void {
		this.isUpdate = on;
	}
}
